import React, { useEffect, useState } from 'react';
import { AuthDTO } from '../models/AuthDTO';
import { APIService } from '../services/APIService';

interface AuthContextProps {
    currentUser: AuthDTO | null,
    children?: React.ReactNode,
    setCurrentUser: (user: AuthDTO | null) => void,
    isUserLoggedIn: boolean,
    userRoles: string[],
    isAdmin: () => boolean,
    isAdministrative: () => boolean,
    preferedView: string,
    technicianCode: string | null,
    isTechnician: () => boolean,
    logoutUser: (user: AuthDTO) => void
}

const AuthContext = React.createContext<AuthContextProps>({
    currentUser: null,
    setCurrentUser: () => { },
    isUserLoggedIn: false,
    userRoles: [],
    isAdmin: () => { return false },
    isAdministrative: () => { return false },
    preferedView: "",
    technicianCode: null,
    isTechnician: () => { return false },
    logoutUser: () => { }
});

interface AuthProviderProps {
    user: AuthDTO | null,
    children?: any
}

export const AuthProvider = (props: AuthProviderProps) => {

    const [currentUser, setCurrentUser] = useState<AuthDTO | null>(props.user? props.user : null);
    const [userRoles, setUserRoles] = useState<string[]>((props.user != null) ? props.user.roles! : []);
    const [isUserLoggedIn, setIsUserLoggedIn] = useState<boolean>(props.user != null ? true : false);
    const [preferedView, setPreferedView] = useState<string>((props.user != null) ? props.user.preferedView : "");
    const [technicianCode, setTechnicianCode] = useState<string>((props.user != null) ? props.user.technicianCode : "");

    //Precisamos disto para guardar o token, 
    //caso contrario, ao refrescar a página manualmente somos redirecionados para o login
    APIService.SetToken(currentUser?.token ?? null);

    const loginUser = (user: AuthDTO | null) => {

        //Se não for um user válido
        if (isUserValid(user) === false) {
            setCurrentUser(null);
            setIsUserLoggedIn(false);
            setUserRoles([]);
            setPreferedView("");
            setTechnicianCode("");
            return;
        }

        setCurrentUser(user);
        setIsUserLoggedIn(true);
        setPreferedView(user!.preferedView);
        setTechnicianCode(user!.technicianCode);
        if (user != null) {
            setUserRoles(getRoles(user));
        }
    }

    const logoutUser = (user: AuthDTO) => {
        setCurrentUser(null);
        setIsUserLoggedIn(false);
        setUserRoles([]);
    }


    const isUserValid = (user: any): boolean => {
        if (typeof user == 'undefined') return false;
        if (user == null) return false;
        if (user.token == null) return false;

        return true;
    }

    const getRoles = (user: AuthDTO): string[] => {
        var roles: string[] = [];
        if (user.roles !== null && typeof user.roles !== 'undefined') {
            user.roles.forEach((a: string) => {
                roles.push(a)
            });
        }
        return roles;
    }

    const isAdmin = (): boolean => {
        if (currentUser == null) return false;
        if (currentUser.roles == null) return false;
        if (currentUser.roles.length <= 0) return false;
        if (currentUser.roles.findIndex(r => r.toUpperCase() === "ADMIN") !== -1) return true;
        return false;
    }

    const isAdministrative = (): boolean => {
        if (currentUser == null) return false;
        if (currentUser.roles == null) return false;
        if (currentUser.roles.length <= 0) return false;
        if (currentUser.roles.findIndex(r => r.toUpperCase() === "TÉCNICO ESCRITÓRIO") !== -1) return true;
        return false;
    }

    const isTechician = (): boolean => {
        if (currentUser == null) return false;
        if (currentUser.roles == null) return false;
        if (currentUser.roles.length <= 0) return false;
        if (currentUser.roles.findIndex(r => r.toUpperCase() === "TÉCNICO OFICINA") !== -1) return true;
        return false;
    }


    useEffect(() => {
        APIService.SetToken(currentUser?.token ?? null);
        return () => {
        }
    }, [currentUser])


    return (
        <AuthContext.Provider value={{
            currentUser, setCurrentUser: loginUser, isUserLoggedIn: isUserLoggedIn, userRoles,
            isAdmin: isAdmin, logoutUser: logoutUser, isAdministrative: isAdministrative, preferedView: preferedView, technicianCode: technicianCode, isTechnician: isTechician
        }}>
            {props.children}
        </AuthContext.Provider>
    )
}
export const useAuth = () => React.useContext(AuthContext);